module.exports = __webpack_public_path__ + "static/media/money-out.2093489f.gif";